const apiUrl = process.env.REACT_APP_API_URL;

const getContent = (token, stage, cb) => {
    fetch(`${apiUrl}/content/TroubleshootingFAQ?section=${stage}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default getContent;
